<template>
  <div class="p-4 sendtofunder" style="overflow-y: scroll;max-height: 600px;">
    <div v-show="!showEmptyScreen" class="table-container">
      <div class="table-actions mt-5">
        <p class="table-stats">
          {{ $t("general.showing") }}: <b>{{ funderAccounts.length }}</b>
          {{ $t("general.of") }} <b>{{ totalFunderAccounts }}</b>
        </p>

        <transition name="fade" v-if="sendFundersDisable == false">
          <v-dropdown v-if="selectedFunderAccount > 0" :show-arrow="false">
            <span
              slot="activator"
              href="#"
              class="table-actions-button dropdown-toggle"
            >
              {{ $t("general.actions") }}
            </span>
            <v-dropdown-item>
              <div class="dropdown-item" @click="invoiceSendtoFunder">
                <font-awesome-icon
                  icon="paper-plane"
                  class="dropdown-item-icon"
                />
                {{ $t("invoices.funder.sendToFunder") }}
              </div>
            </v-dropdown-item>
          </v-dropdown>
        </transition>
      </div>

      <div class="custom-control"></div>

      <table-component
        ref="table"
        :show-filter="false"
        :data="fetchData"
        table-class="table"
      >
        <table-column
          :sortable="false"
          :filterable="false"
          cell-class="no-click"
        >
          <template slot-scope="row">
            <div class="custom-control custom-radio">
              <input
                :disabled="sendFundersDisable"
                :id="row.id"
                v-model="selectFunderField"
                :value="row.id"
                type="radio"
                class="custom-control-input"
              />
              <label :for="row.id" class="custom-control-label" />
            </div>
          </template>
        </table-column>

        <table-column
          :label="$t('accounts.company_name')"
          show="company_name"
        />
        <table-column :label="$t('accounts.phone')" show="phone" />

        <table-column
          :label="$t('accounts.added_on')"
          sort-as="created_at"
          show="formattedCreatedAt"
        />

        <table-column
          :label="$t('accounts.status')"
          sort-as="status"
          show="UpperCaseStatus"
        />
      </table-component>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      sendFundersDisable: false,
      sendFunders: [],
      userAccounts: [],
      showFilters: false,
      isLoading: false,
      filtersApplied: false,
      tableDivId: "tableDivId",
      account_types: [],
      isRequestOngoing: true,
      filters: {
        display_name: "",
        company_name: "",
        phone: "",
        role: "",
        status: "",
        account_type: ""
      }
    };
  },
  computed: {
    showEmptyScreen() {
      return !this.totalFunderAccounts && !this.isRequestOngoing;
    },
    filterIcon() {
      return this.showFilters ? "times" : "filter";
    },

    ...mapGetters("invoice", ["selectedInvoices"]),
    ...mapGetters("account", [
      "accounts",
      "selectedAccounts",
      "selectedFunderAccount",
      "totalAccounts",
      "selectAllField",
      "funderAccounts",
      "totalFunderAccounts",
      "selectAllFunderField"
    ]),
    selectFunderField: {
      get: function() {
        return this.selectedFunderAccount;
      },
      set: function(val) {
        this.selectFunderAccount(val);
      }
    },
    selectAllFieldStatus: {
      get: function() {
        return this.selectAllFunderField;
      },
      set: function(val) {
        this.setSelectAllFunderState(val);
      }
    }
  },
  watch: {
    filters: {
      handler: "setFilters",
      deep: true
    }
  },
  methods: {
    ...mapActions("account", [
      "selectAllFunderAccount",
      "selectFunderAccount",
      "fetchFunderAccounts",
      "invoiceSendtoFunderAccounts",
      "setSelectAllFunderState"
    ]),
    ...mapActions("invoice", ["bulkProcessRequestedInvoicesWithData"]),
    ...mapActions("modal", ["closeModal", "resetModalData", "setIsSearching"]),

    refreshTable() {
      this.$refs.table.refresh();
    },
    async fetchData({ page, per_page, filter, sort }) {
      let data = {
        role: "admin",
        account_type: "funder",
        orderByField: sort.fieldName || "users.created_at",
        orderBy: sort.order || "desc",
        status: "active",
        limit: 5,
        per_page, // Add rowsPerPage in the API request
        page
      };
      this.isRequestOngoing = true;
      let response = await this.fetchFunderAccounts(data);
      this.isRequestOngoing = false;
      this.account_types = response.data.account_types;
      this.userAccounts = response.data.accounts.data;
      return {
        data: this.userAccounts,
        pagination: {
          totalPages: response.data.accounts.last_page,
          currentPage: page,
          rowsPerPage: response.data.accounts.per_page // Add rowsPerPage in the API request
        }
      };
    },
    setFilters() {
      this.filtersApplied = true;
      this.refreshTable();
    },
    async invoiceSendtoFunder() {
      let data = {
        ids: this.selectedInvoices,
        userId: this.selectedFunderAccount,
        request_level: "SendToFunder"
      };

      this.isRequestOngoing = true;
      this.sendFundersDisable = true;
      this.isLoading = true;

      this.closeModal();
      swal({
        title: this.$t("general.are_you_sure"),
        text: this.$tc("invoices.admin_send_to_funder"),
        icon: "/assets/icon/paper-plane-solid.svg",
        buttons: true,
        dangerMode: true
      }).then(async value => {
        if (value) {
          this.setIsSearching();
          let res = await this.bulkProcessRequestedInvoicesWithData(data);
          this.setIsSearching();
          if (res.data.success === true) {
            location.reload();
            this.filtersApplied = false;
            this.resetSelectedInvoices();
            window.toastr["success"](
              this.$t("prepayments.prepayment_request_send_message")
            );
          } else if (res.data.success === false) {
            window.toastr["error"](res.data.error);
          }
        }
      });
    }
  }
};
</script>
<style scoped>
#tableDivId {
  min-height: 0px;
}
</style>
<style>
.sendtofunder .dropdown-container {
  left: -120px;
}
</style>
